declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

type Params = Record<string, any>;
const defaults: Params = {};

// Analytics Constants
export const EVENT_CATEGORY = {
  ONBOARDING: "onboarding",
} as const;

export const GA4_EVENTS = {
  BEGIN_ONBOARDING: "begin_onboarding",
  VIEW_STEP: "view_step",
  COMPLETE_STEP: "complete_step",
  NAVIGATE_BACK: "navigate_back",
  JOIN_WAITLIST: "join_waitlist",
  ENTERPRISE_INQUIRY: "enterprise_inquiry",
  BEGIN_CHECKOUT: "begin_checkout",
  COMPLETE_ONBOARDING: "complete_onboarding",
  MANUAL_EVENT_PURCHASE: "manual_event_PURCHASE",
} as const;

export type EventCategory =
  (typeof EVENT_CATEGORY)[keyof typeof EVENT_CATEGORY];
export type GA4Event = (typeof GA4_EVENTS)[keyof typeof GA4_EVENTS];

export function setFunnel(funnel_id: string, funnel_session_id?: string) {
  defaults.funnel_id = funnel_id;
  defaults.funnel_session_id =
    funnel_session_id ?? defaults.funnel_session_id ?? crypto.randomUUID();
}

export function setStep(step: number, step_name: string) {
  defaults.step = step;
  defaults.step_name = step_name;
}

export function gaEvent(name: string, params?: Params) {
  window.gtag?.("event", name, { ...defaults, ...params });
}
